export class ResponseDto {
}
export var ListingType;
(function (ListingType) {
    ListingType[ListingType["SalesDesc"] = "Sales"] = "SalesDesc";
    ListingType[ListingType["Sales"] = 1] = "Sales";
    ListingType[ListingType["RentalsDesc"] = "Rentals"] = "RentalsDesc";
    ListingType[ListingType["Rentals"] = 2] = "Rentals";
})(ListingType || (ListingType = {}));
